<!-- <ng-select [items]="userProfiles" bindLabel="typeName" bindValue="userTypeId" [virtualScroll]="true"
    placeholder="Please Select" [(ngModel)]="userId" (ngModelChange)="userChanged()" [selectOnTab]="true">
</ng-select> -->

<search-dropdown 
  [items]="userProfiles" 
  [label]="'typeName'" 
  [uid]="'userTypeId'" 
  [placeholder]="placeholder"
  (afterChange)="userChanged($event)"
  [(ngModel)]="userId">
</search-dropdown>